import { render } from "./aside.vue?vue&type=template&id=479046f8&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"

import "./aside.vue?vue&type=style&index=0&id=479046f8&scoped=true&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479046f8"]])

export default __exports__